export default ({ redirect, route }) => {
  // Check if the current path is from Groups section
  if (route.path && !route.path.startsWith('/groups')) {
    return
  }
  // https://github.com/nuxt/website-v2/pull/1199/files
  return redirect(process.env.COMMUNITY_SITE_URL)
}
